import styled from "styled-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexColumn)<{ isVisible: boolean }>`
    gap: 16px;
    width: 462px;
    padding-left: 38px;
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
`;
